import currency from '../helpers/parseCurrency'

const getPriceFlavor = (item, price_flavor) => {
    return item.price_to ? price_flavor - (price_flavor * (item.percentage_discount / 100)) : price_flavor
}

const parseNumber = value => {
    if(!value) {
        return 0
    }

    const normalized = String(value).replace(/\s/g, '')
    if(normalized.includes(',')) {
        return Number(normalized.replace(/\./g, '').replace(',', '.'))
    }

    return Number(normalized)
}

export const getInterestFreeInstallments = (item, company, totalPriceAdditionalItems, getFlavorsSelected, quantityFractional, product_page, product_modal) => {
    const products_settings = company?.products_settings ?? {}
    const interest_free_installments = parseNumber(products_settings.parcelas_sem_juros_credito)
    const minimum_installment_value = parseNumber(products_settings.valor_minimo_parcela)
    const price_item = !getFlavorsSelected.length && !product_page && !product_modal ?
        parseFloat(item.price_to ?? item.pro_price_site) + totalPriceAdditionalItems :
        Math.max(
            ...getFlavorsSelected.map(
                flavor => item?.fractional_sale ?
                    getPriceFlavor(item, flavor.price * Number(quantityFractional)) :
                    getPriceFlavor(item, flavor.price)
            ), parseFloat(item.price_to ?? item.pro_price_site)
        ) + totalPriceAdditionalItems

    if(products_settings.installments_display_type == 'max_card') {
        let max_card_installments = parseInt(parseNumber(products_settings.max_card_installments))

        if(!price_item || !max_card_installments) {
            return null
        }

        if(minimum_installment_value > 0) {
            const max_installments_by_minimum_value = parseInt(price_item / minimum_installment_value)
            max_card_installments = Math.min(max_card_installments, max_installments_by_minimum_value || 1)
        }

        return 'em até ' + max_card_installments + 'x no cartão'
    }

    if(!price_item || !interest_free_installments) {
        return null
    }
    const price = parseFloat(price_item / interest_free_installments)
    const parcelas = parseInt (price_item / minimum_installment_value)
    const minimum_value = parseFloat(price_item / parcelas)

    if(minimum_installment_value > price_item) {
        return 'em até 1x de ' + currency.money(price_item) + ' sem juros '
    } else if (interest_free_installments > parcelas) {
        return 'em até ' + parcelas + 'x de ' + currency.money(minimum_value) + ' sem juros'
    } else {
        return 'em até ' + interest_free_installments + 'x de ' + currency.money(price) + ' sem juros'
    }
}

export const getRating = (rating) => {
    let data = ""
    for(var i = 0; i < rating; i++) {
        data = data+"\\e852 ";
    }
    return data
}

export const getDiscountPix = (company) => {
    const discount_pix =  company?.products_settings?.discount_pix ?? 0
    if(!discount_pix) {
        return null
    }
    return discount_pix
}

export const TYPE_PRODUCT = 1;
export const TYPE_VARIATION = 2;
export const TYPE_ADDITIONAL_ITEM = 3;
